<template>
  <div>
    <div v-if="!showAdicionar"
         class="container eHabilitacao mt-2">
      <div v-if="show"
           class="row">
        <div class="col-4">
          <listagem class="row "
                    :prop-actual-page="actualPage"
                    :prop-documentos="compDocumentos('Comum')"
                    :prop-certidoes="compDocumentos('Certidões')"
                    :prop-pages-select="pagesSelect"
                    :prop-habilitacao="propHabilitacao"
                    :prop-qtd-pages="qtdPagesTotal"
                    @onSetActualPage="(indice) => setActualpage(indice)"
                    @onSetLastPage="actualPage = qtdPagesTotal"
                    @onActualPageMinus="actualPage--"
                    @onActualPagePlus="actualPage++"
                    @onSetOrdem="(direction, document) => setOrdem(direction, document)" />

          <div class="row mt-3">
            <div class="col">
              <b-button @click="showAdicionar = true">
                <icon-svg icon="add"
                          class="icon--xs icons--white" />
                Juntada
              </b-button>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col">
              <b-button variant="outline-primary"
                        @click="$root.$emit('bv::show::modal', 'e-habilitacao-impressao-documentos')">
                Selecionar documentos para imprimir
              </b-button>
            </div>
          </div>
        </div>

        <visualizador class="col"
                      :prop-url-pdf="urlPdf"
                      :prop-actual-page="actualPage"
                      :prop-sequencia-diff="sequenciaDiff"
                      @onRestore="restore"
                      @onSaveOrdem="saveOrdem" />

        <modal-impressao :prop-documentos="compDocumentos('Comum')"
                         :prop-certidoes="compDocumentos('Certidões')"
                         :prop-cumprimento="!!propHabilitacao.casamento"
                         @onImprimir="(docs) => imprimirEHabilitacao(docs)" />
      </div>
    </div>

    <div v-if="showAdicionar">
      <preparar-processo :prop-documentos="documentosHabilitacao"
                         :prop-habilitacao="propHabilitacao"
                         :prop-tipo-documento="propHabilitacao.tipo_casamento"
                         @onEditDoc="editarDocumento"
                         @onDeleteDoc="excluirDocumento"
                         @onNewDocument="novoDocumento" />

      <hr class="pt-0 mt-0">
      <div class="row">
        <div class="col text-right">
          <b-button v-if="!blockBack"
                    variant="light"
                    class="mr-2"
                    @click="showAdicionar = false">
            Voltar
          </b-button>
          <b-button v-if="blockBack"
                    v-b-tooltip="'Para voltar clique em Salvar ou recarregue a página'"
                    variant="light"
                    class="mr-2">
            Voltar
          </b-button>
          <b-button @click="updateHabilitacaoDocumentos">
            Salvar
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import Listagem from "@/components/SofiaRei/HabilitacaoCasamento/Resumo/EHabilitacao/Listagem"
  import Visualizador from "@/components/SofiaRei/HabilitacaoCasamento/Resumo/EHabilitacao/Visualizador"
  import ModalImpressao from "@/components/SofiaRei/HabilitacaoCasamento/Resumo/EHabilitacao/ModalImpressao"
  import PrepararProcesso from "@/components/SofiaRei/HabilitacaoCasamento/PrepararProcesso"

  /* services */
  import HabilitacaoService from "@/services/Registros/Habilitacao"
  import eHabilitacaoService from "@/services/Registros/Habilitacao/eHabilitacaoService"
  import UploadTemporarioService from "@/services/Arquivos/UploadTemporarioService"

  /* libraries */
  import { PDFDocument } from 'pdf-lib'

  export default {
    name: "EHabilitacao",
    components: {
      Listagem,
      Visualizador,
      ModalImpressao,
      PrepararProcesso
    },
    props: {
      propHabilitacao: {
        type: Object,
        default: () => ({})
      }
    },

    data () {
      return {
        listagem: null,
        urlPdf: null,
        qtdPagesTotal: 0,
        actualPage: 1,
        documentosListagem: [],
        documentosHabilitacao: [],
        documentosBackupOrder: [],
        show: false,
        showAdicionar: false,
        sequencias: {
          atual: [],
          nova: []
        },
        deleteds: {
          habilitacaoDocumentos: []
        },
        blockBack: false
      }
    },
    computed: {
      pagesSelect () {
        const qtdPages = []
        for (let i = 1; i <= this.qtdPagesTotal; i++) {
          qtdPages.push(i)
        }
        return qtdPages
      },

      sequenciaDiff () {
        let valueBool = false
        if (this.sequencias.nova.length == 0) {
          valueBool = true
        } else {
          const atual = this.sequencias.atual.map(sequencia => sequencia.habilitacao_casamento_documento_id).join('')
          const nova = this.sequencias.nova.map(sequencia => sequencia.habilitacao_casamento_documento_id).join('')

          if (atual == nova) {
            valueBool = true
          }
        }

        return valueBool
      }
    },
    watch: {
      propDocumentos () {
        this.init()
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      async init () {
        try {
          loader({ active: true })
          await this.getPdfJoined()

          await this.getQtdPdfSingle()
        } finally {
          loader({ active: false })
        }
      },
      compDocumentos (tipo) {
        const order = (a, b) => {
          if (a.ordem > b.ordem) return 1
          if (b.ordem > a.ordem) return -1

          return 0
        }

        if (this.documentosListagem) {
          /* separando listagem com ordem e sem ordem */
          const ordered = this.documentosListagem.filter(doc => doc.tipo_documento == tipo && (doc.url_temp || doc.url_s3) && !!doc.ordem).sort(order)
          const unordered = this.documentosListagem.filter(doc => doc.tipo_documento == tipo && (doc.url_temp || doc.url_s3) && !doc.ordem).sort(order)

          /* pegando valor da ordem do ultimo objeto ordenado */
          let lastOrder = ordered[(ordered.length - 1)] && ordered[(ordered.length - 1)].ordem

          /* caso não exista retornará nulo */
          if (!lastOrder && ordered.length > 0) return []

          // caso não tenha nenhum ordenado, colocamos ordem 0 no lastOrdem
          if (ordered.length == 0) lastOrder = 0

          /* percorre o array unordered pra atribuir uma ordem dinamica para objetos sem ordem */
          for (let i = 0; i < unordered.length; i++) {
            unordered[i].ordem = lastOrder + (i + 1)
          }

          return [
            ...ordered,
            ...unordered
          ]
        } else {
          return []
        }
      },
      compCorrespondentes (correspondente) {
        if (this.documentosListagem)
          return this.documentosListagem.filter(documento => documento.correspondente == correspondente && documento.url_temp)
        else
          return null
      },
      async getQtdPdfSingle () {
        /* função que pega a qtd de paginas de cada pdf que é juntado depois na e-habilitacao final */
        /* a quantidade servirá para quando clicar em algum pdf listado, ele ir direto para sua pagina correspondente */
        try {
          loader({ active: true, text: "Carregando PDF's separados" })
          const listagem = []

          this.documentosListagem && this.documentosListagem.forEach(async (documento) => {
            if (!documento.quantidade) {
              const file = await eHabilitacaoService.getPdfAws(documento.habilitacao_casamento_documento_id)

              const qtd = await this.getQtdPages(file)

              documento.quantidade = qtd
            }

            listagem.push(documento)
            await this.getPageIndex()
          })

          this.documentosListagem = listagem
        } catch (e) {
          console.error('Não foi possível carregar contagem de paginas dos PDF separados',e)
        } finally {
          loader({ active: false })
        }
      },
      async getPdfJoined () {
        try {
          loader({ text: 'Carregando PDF...', active: true})

          /* pegando objeto PDF com todos os documentos juntos em um único */
          const file = await eHabilitacaoService.joinDocuments(this.propHabilitacao)

          /* criando url BLOB */
          let blob = base64toBlob(file.fileOutput, 'application/pdf')
          let url = window.URL.createObjectURL(blob)

          const arrayBuffer = await blob.arrayBuffer()

          /* pegando a qtd de paginas do PDF */
          this.qtdPagesTotal = await this.getQtdPages(arrayBuffer)

          this.urlPdf = url
          this.documentosListagem = file.listagem
          this.documentosHabilitacao = this.propHabilitacao.documentos
          this.documentosBackupOrder = JSON.parse(JSON.stringify([...this.documentsSort()]))
        } catch (e) {
          console.error('Erro ao carregar PDF em eHabilitacao', e)
        } finally {
          loader({ active: false})
          this.show = true
        }
      },

      cancelEdit () {
        this.$refs["modal-editar-doc"].hide()
      },

      async getQtdPages (file) {
        const pdf = await PDFDocument.load(file, { ignoreEncryption: true })

        return pdf.getPages().length
      },

      documentsSort () {
        /* separando documentos de acordo com a tag */
        const documentos = this.compDocumentos('Comum')
        const certidoes = this.compDocumentos('Certidões')

        return [
          ...documentos,
          ...certidoes
        ]
      },

      getSequencia (docs) {
        return docs.map(doc => {
          return {
            habilitacao_casamento_documento_id: doc.habilitacao_casamento_documento_id,
            ordem: doc.ordem
          }
        })
      },

      async getPageIndex () {
        const documentosOrdenados = this.documentsSort()
        this.sequencias.atual = this.getSequencia(documentosOrdenados)

        /* totalPages representa a quantidade e paginas da e-habilitacao */
        let totalPages = 0
        documentosOrdenados.map((doc) => {
          /* no final qtdPages tem que estar com a mesma quantidade de paginas da e-habilitacao */
          /* a cada documento percorrido, é incrementado a qtd de pagina em totalPages */

          totalPages = parseFloat(totalPages) + parseFloat(doc.quantidade) // doc.quantidade é a quantidade de paginas de cada pdf sozinho

          doc.indicePage = totalPages - (parseFloat(doc.quantidade) - 1)
        })
      },

      setOrdem (direction, document) {
        /* pegando array por tipo_documento */
        const list = this.compDocumentos(document.tipo_documento)

        /* criando objeto da posição anterior e próxima para mudança de lugar */
        const previous = {
          index: list.indexOf(document),
          ordem: document.ordem
        }
        const next = {
          index: null,
          ordem: null
        }

        /* de acordo com o tipo de direção, o próximo index muda */
        switch (direction) {
        case "up":
          next.index = previous.index - 1
          next.ordem = list[next.index].ordem
          break
        case "down":
          next.index = previous.index + 1
          next.ordem = list[next.index].ordem
          break
        }

        /* e a mudança da ordem da posição anterior e proximo é feito */
        list[next.index].ordem = previous.ordem
        list[previous.index].ordem = next.ordem

        this.sequencias.nova = this.getSequencia(this.documentsSort()).filter(doc => !!doc.habilitacao_casamento_documento_id)
      },

      restore () {
        this.documentsSort().map(doc => {
          const docFind = this.documentosBackupOrder.find(docBkp => docBkp.habilitacao_casamento_documento_id == doc.habilitacao_casamento_documento_id)
          doc.ordem = docFind.ordem
        })

        this.sequencias.nova = this.getSequencia(this.documentsSort())
      },

      saveOrdem () {
        objSwal.question.title = "Deseja atualizar ordem da E-habilitação?"
        objSwal.question.text = "A ordem será atualizada e o visualizador será mostrado com a ordem atualizada."
        objSwal.question.cancelButtonText = "Não"
        objSwal.question.confirmButtonText = "Sim"
        const { id } = this.$route.params

        Swal.fire(objSwal.question).then(async res => {
          if (res.value) {
            try {
              loader({ active: true, text: 'Atualizando ordem...' })
              await eHabilitacaoService.updateOrdem(id, this.sequencias.nova)
              this.init()
            } catch (e) {
              objSwal.error.title = "Erro ao atualizar ordem!"
              objSwal.error.text = "Tente novamente"
              Swal.fire(objSwal.error)
              loader({ active: false })
            }
          }
        })
      },

      async imprimirEHabilitacao (docs) {
        try {
          loader({ active: true, text: "Gerando E-habilitação..." })

          /* pegando pdf pelo service */
          const pdfFile = await eHabilitacaoService.joinDocuments(this.propHabilitacao, docs, { filtro: true })

          /* criando url blob temporária */
          let blob = base64toBlob(pdfFile.fileOutput, 'application/pdf')
          let url = window.URL.createObjectURL(blob)

          /* criando ancora para realizar o download */
          let a = document.createElement("a")
          document.body.appendChild(a)
          a.href = url
          a.download = "E-Habilitação"
          a.click()
          a.remove()
        } catch (e) {
          console.error('Erro no download da E-Habilitação', e)
          objSwal.error.title = "Erro no download da E-Habilitação"
          objSwal.error.text = "Tente novamente!"
          Swal.fire(objSwal.error)
        } finally {
          loader({ active: false })
        }
      },

      novoDocumento (documents) {
        this.documentosHabilitacao = [ ...documents ]
        this.blockBack = true
        this.$emit('onNewDocs', documents)
      },

      async excluirDocumento (documento) {
        let indexDocument = this.findDoc(documento)

        if (indexDocument != null) {

          /* se não for temporário, irá ser enviado para o servide em "deleteds" */
          !!documento.habilitacao_casamento_documento_id && this.deleteds.habilitacaoDocumentos.push(documento.habilitacao_casamento_documento_id)

          /* apagando do array */
          this.documentosHabilitacao.splice(indexDocument, 1)

          // apagamos o pdf
          if (!documento.habilitacao_casamento_documento_id) {
            await UploadTemporarioService.deleteTemporario(documento.url_s3)
          }

          this.blockBack = true
        }
      },

      editarDocumento (documento) {
        let indexDocument = this.findDoc(documento)
        Object.assign(this.documentosHabilitacao[indexDocument], documento)
        this.blockBack = true
      },

      findDoc (documento) {
        let indexDocument = null
        let docFind = null

        if (!!documento.habilitacao_casamento_documento_id) {
          /* para caso seja registro */
          docFind = this.documentosHabilitacao.find(doc => doc.habilitacao_casamento_documento_id == documento.habilitacao_casamento_documento_id)
          indexDocument = this.documentosHabilitacao.indexOf(docFind)
        } else {
          /* para caso seja temporário */
          docFind = this.documentosHabilitacao.find(doc => doc.url_temp == documento.url_temp)
          indexDocument = this.documentosHabilitacao.indexOf(docFind)
        }

        return indexDocument
      },

      updateHabilitacaoDocumentos () {
        const habilitacao = { ...this.propHabilitacao }
        habilitacao.registro = { ...this.propHabilitacao.registro }
        habilitacao.pessoas = [ ...this.propHabilitacao.registro.pessoas ]
        habilitacao.documentos = [ ...this.documentosHabilitacao ]
        habilitacao.deleteds = { ...this.deleteds }

        let swalQuestion = { ...objSwal.question }
        swalQuestion.title = "Confirmar atualização?"
        swalQuestion.cancelButtonText = "Não"
        swalQuestion.confirmButtonText = "Sim"
        Swal.fire(swalQuestion).then(async status => {

          if (status.value === true || status.dismiss == "cancel") {
            try {
              this.show = false
              loader({ text: "Atualizando Habilitação...", active: true })
              if (status.value === true) {
                const { params: { id } } = this.$route
                await HabilitacaoService.updateHabilitacao(habilitacao, id)
                this.$emit('onEHabilitacaoAtualizada')
                setTimeout(() => {
                  loader({ text: 'Carregando PDF...', active: true })
                  this.show = true
                }, 1000)
              }
            } catch (e) {
              objSwal.error.title = "Erro ao atualizar."
              objSwal.error.text = ''
              Swal.fire(objSwal.error)
              console.error('Erro ao atualizar Habilitação', e)
            } finally {
              loader({ active: false })
            }

          }

        })


      },

      setActualpage (indice) {
        this.show = false
        this.actualPage = indice

        setTimeout(() => {
          this.show = true
        }, 100)
      }
    }
  }
</script>

<style lang="scss">
  .label {
    font-size: 14px;
  }

  .eHabilitacao {
    &--border {
      border: 1px solid black;
    }

    &--header {
      background-color: black;
      color: white;
    }

    &--header50 {
      height: 50px;
    }

    &--cursor {
      cursor: pointer;
    }

    &--cursor:hover {
      cursor: pointer;
      background-color: #086aae;
      color: #fff;
    }

    &--btnTransparent {
      background-color: transparent;
      border: none;
    }

    &--btnTransparent:disabled {
      background-color: transparent;
      border: none;
    }

    &--marginMinusRight {
      margin-left: -8px;
    }

    &--marginMinusLeft {
      margin-right: -8px;
    }
  }

  .document-preview {
    height: 400px !important;
  }

  .vSelect {
    width: 100%;
    background-color: white;
  }

  .inline-flex {
    display: inline-flex;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .block-leitor-pdf {
    z-index: 10;
    position: absolute;
    background-color: #000000d9;
    color: #fff;
  }
</style>
